import { Client } from 'colyseus.js';

const wsUrl = import.meta.env.VITE_WS_URL || 'ws://localhost:3041';
export const colyseusClient = new Client(wsUrl);
